import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { p as props } from './componentEl-c8b73b10.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { a as addBorderClasses, b as borderPropTypes } from './border-27b45cc2.js';
import { a as addSpacingClasses, m as marginPropTypes, p as paddingPropTypes } from './spacing-7e57ffb0.js';

/**
Generic component for wrappin around content, meant to wrap a single child
*/
function Wrapper({
  componentEl: Component,
  margin,
  padding,
  className,
  background,
  fullWidth,
  fullHeight,
  border,
  ...otherProps
}) {
  let cssClasses = ['st_boxsize--border'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    padding,
    cssClasses
  });
  cssClasses = addBorderClasses(border, cssClasses);
  if (background) cssClasses.push(`st_bg--${background}`);
  if (fullWidth) cssClasses.push('st_width--full');
  if (fullHeight) cssClasses.push('st_height--full');
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps));
}
Wrapper.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** padding for component, if any */
  padding: paddingPropTypes,
  /** background color for wrapper, if any */
  background: PropTypes.oneOf(['page', 'content']),
  /** whether button takes up all available horizontal space */
  fullWidth: PropTypes.bool,
  /** whether button takes up all available vertical space */
  fullHeight: PropTypes.bool,
  /** optional standard border */
  border: borderPropTypes
};
Wrapper.defaultProps = {
  componentEl: 'div',
  className: null,
  margin: null,
  padding: null,
  background: null,
  fullWidth: false,
  fullHeight: false,
  border: null
};

export { Wrapper as W };
